/**
 * Shared merge-run types for the compliance-merge jobstisio client.
 * Kept in its own module so client components can import types and display
 * constants without pulling the Node-only service (pino logger, env keys)
 * into the browser bundle.
 */

export interface MergeRegulation {
  regulationId: string;
  partyName: string;
}

/** Mirrors overlapmatrix.Item JSON tags (lowercase) as persisted in article_refs. */
export interface MergeClusterArticle {
  id: string;
  reg: string;
  section: string;
  article: string;
  party: string;
  text: string;
}

export interface MergeCluster {
  index: number;
  title: string;
  description: string;
  articles: MergeClusterArticle[];
  pairCount: number;
  avgScore: number | null;
  singleton: boolean;
  /** Jev Choice verdict: obligation | permit | reporting; null for pre-column runs. */
  complianceType: 'obligation' | 'permit' | 'reporting' | null;
  /** Drafted actionable checklist steps; empty for verbatim or pre-steps rows. */
  steps?: string[];
}

/** One party picked for a target description, with the model's reason. */
export interface PartySelection {
  name: string;
  reason: string;
}

export const COMPLIANCE_TYPE_LABEL: Record<string, string> = {
  obligation: 'Kewajiban',
  permit: 'Izin',
  reporting: 'Pelaporan',
};

export interface MergeRun {
  id: string;
  partyName: string;
  regulations: string[];
  status: 'pending' | 'running' | 'completed' | 'failed';
  errorMessage: string | null;
}

export interface MergeResult {
  run: MergeRun;
  clusters: MergeCluster[];
}

export interface MergeHistoryRun {
  id: string;
  partyName: string;
  regulations: string[];
  status: string;
  createdAt: string;
  clusters: number;
  merged: number;
}
